import { render, staticRenderFns } from "./ChoiceQuestion.vue?vue&type=template&id=f4e4deac&scoped=true&"
import script from "./ChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./ChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceQuestion.vue?vue&type=style&index=0&id=f4e4deac&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e4deac",
  null
  
)

export default component.exports